
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://degpzylgevdzcvoophns.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRlZ3B6eWxnZXZkemN2b29waG5zIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE5MTIwNzEsImV4cCI6MjA1NzQ4ODA3MX0.IqBK6_2UnfwvnO6BokbsWrPYW-QuGHhMBNxBr9knd8U';

export const supabase = createClient(supabaseUrl, supabaseKey);

// Initialize settings if they don't exist
export const initializeSettings = async () => {
  try {
    const { data, error } = await supabase
      .from('settings')
      .select('*')
      .eq('key', 'pledge_count')
      .single();

    if (!data) {
      await supabase
        .from('settings')
        .insert([{ key: 'pledge_count', value: '12547' }]);
    }
  } catch (error) {
    console.error('Error initializing settings:', error);
  }
};

// Helper function to check if user is admin
export const isAdmin = async (email) => {
  if (!email) return false;
  
  try {
    const { data, error } = await supabase
      .from('admins')
      .select('*')
      .eq('email', email)
      .single();

    if (error) throw error;
    return !!data;
  } catch (error) {
    console.error('Error checking admin status:', error);
    return false;
  }
};
